import React from 'react';

interface AddActivityButtonProps {
  onClick: () => void;
  disabled: boolean;
}

const AddActivityButton: React.FC<AddActivityButtonProps> = ({ onClick, disabled }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!disabled) {
      onClick();
    }
  };

  return (
    <button 
      onClick={handleClick}
      disabled={disabled}
      className={`w-full p-2 border-2 border-dashed ${
        disabled
          ? 'border-gray-200 text-gray-400 cursor-not-allowed'
          : 'border-gray-300 text-gray-500 hover:border-blue-400 hover:text-blue-600'
      } rounded text-sm transition-colors`}
    >
      <svg className="w-4 h-4 inline mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
      </svg>
      Thêm hoạt động
    </button>
  );
};

export default AddActivityButton; 